/**
 * DH Scroll Reveal
 * Tags any element with [data-dh-reveal] for fade-in-on-scroll.
 * Add [data-dh-delay="1..4"] for stagger.
 *
 * Uses IntersectionObserver — supports reduced-motion via CSS,
 * runs once per element (unobserves after first reveal).
 */
(function () {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;

  const REVEAL_SELECTOR = '[data-dh-reveal]:not([data-dh-visible="true"])';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-dh-visible', 'true');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.05,
    }
  );

  function observeAll() {
    document.querySelectorAll(REVEAL_SELECTOR).forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Re-observe new elements added later (Shopify section reload, infinite scroll, etc.)
  if (window.MutationObserver) {
    new MutationObserver(() => observeAll()).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
